export const CUSTOMER_TYPE = {
  B2B: 'B2B',
  B2C: 'B2C'
}

export const SEE_TUTORIAL_AGAIN_STEP_ID = 'see-tutorial-again'
export const MY_ACCOUNT_NAV_MENU_CLASS = '.rhg-avatar'
export const ACCOUNT_TUTORIAL_TYPES = {
  OFFCANVAS: 'offcanvas',
  NAVBAR: 'navbar',
  NONE: ''
}

export const START_BEHAVIOR = 'start'
export const END_BEHAVIOR = 'end'
export const CENTER_BEHAVIOR = 'center'

export const STEP_TYPES = {
  'off-canvas-loyalty': ACCOUNT_TUTORIAL_TYPES.OFFCANVAS,
  membershipAndTiers: ACCOUNT_TUTORIAL_TYPES.NONE,
  yourBenefits: ACCOUNT_TUTORIAL_TYPES.NONE,
  'My-profile': ACCOUNT_TUTORIAL_TYPES.NAVBAR,
  'My-statements': ACCOUNT_TUTORIAL_TYPES.NAVBAR,
  'My-reservations': ACCOUNT_TUTORIAL_TYPES.NAVBAR
}

export const STEP_SCROLL_POSITION_DESKTOP = {
  'off-canvas-loyalty': CENTER_BEHAVIOR,
  membershipAndTiers: CENTER_BEHAVIOR,
  yourBenefits: START_BEHAVIOR,
  'My-profile': CENTER_BEHAVIOR,
  'My-statements': CENTER_BEHAVIOR,
  'My-reservations': CENTER_BEHAVIOR,
  'see-tutorial-again': CENTER_BEHAVIOR
}

export const STEP_SCROLL_POSITION_RESPONSIVE = {
  'off-canvas-loyalty': START_BEHAVIOR,
  membershipAndTiers: START_BEHAVIOR,
  yourBenefits: START_BEHAVIOR,
  'My-profile': CENTER_BEHAVIOR,
  'My-statements': CENTER_BEHAVIOR,
  'My-reservations': CENTER_BEHAVIOR,
  'see-tutorial-again': START_BEHAVIOR
}

export const DEFAULT_POSITION = 'bottom'

export const OFFCANVAS_LOYALTY_ID = 'off-canvas-loyalty'
export const OFFCANVAS_LOYALTY_OVERFLOW_CLASS = 'overflow-inherit'
export const OFFCANVAS_LOYALTY_CLASS = 'customer-info-modal-content'

export const OFFCANVAS_RESPONSIVE_TARGETID = 'off-canvas-user-profile-responsive'

export const OFFCANVAS_RESPONSIVE_HIGHLIGHTED_ID = 'header'

export const STEP_PROPERTIES = {
  POSITION: 'position',
  HIGHLIGHTED_ID: 'highlightedId',
  TARGET_ID: 'targetId'
}

export const corporateRoles = {
  ADMINISTRATOR: 'administrator',
  DEPUTY: 'deputy',
  BOOKER: 'booker',
  TMC_ADMIN: 'tmc admin',
  TMC_BOOKER: 'tmc booker',
  PCR_ADMIN: 'pcr admin',
  PCR_BOOKER: 'pcr booker'
}

export const memberTypeAccount = {
  PERSONAL: 'PERSONAL',
  CORPORATE: 'CORPORATE',
  BUSINESS: 'BUSINESS'
}

export const adminType = {
  CORPORATE: 'CORPORATE',
  R4U: 'R4U',
  HYBRID: 'HYBRID'
}

export const programType = {
  RR: 'CORPORATE',
  R4U: 'R4U',
  ALL: 'ALL'
}

export const companyMemberTypes = {
  R4U: [
    'pcr_admin',
    'pcr_booker',
    'tmc_admin',
    'tmc_booker',
    'pcradmin',
    'pcrbooker',
    'tmcadmin',
    'tmcbooker'
  ],
  CORPORATE: ['corp_admin', 'corp_deputy', 'corp_booker', 'corpadmin', 'corpdeputy', 'corpbooker']
}

export const serviceLineProgramType = {
  CORP: '?memberType=corp',
  B2B: '',
  B2C: {
    vip: '?memberType=B2C&tier=Vip',
    premium: '?memberType=B2C&tier=Premium'
  }
}

export const OFFER_SLIDER_LIMIT = 20
export const DNA_PREFIX = 'DNA-'
